import React from 'react';
import FeatureTab from './FeatureTab';
import { FeatureToggle } from '@components/common';
import renderShared from '@components/common/Dashboard/SharedTabs';
import DashboardPrompt from '@components/common/DashboardNavigator/DashboardModal';
import featureNames from '@utils/featureToggle/constants';
import AccessWrapper from './AccessWrapper';
import SavedDashboardsTab from './SavedDashboardsTab';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';
import DashboardList from './DashboardList';
import {
  TAB_TITLE_AIALERTS,
  TAB_TITLE_PROMPT,
  TAB_TITLE_METRIC_LENS,
  TAB_TITLE_OVB,
  TAB_TITLE_TRENDS,
  VIEWER_MODULE,
  TAB_TITLE_AI_ROADMAP,
  TAB_TITLE_NOC,
} from '@utils/constants';
import UseCases from '../UseCases';

const EIAITabs = ({ shareId }) => {
  const renderSharedTab = renderShared(shareId);

  return (
    <>
      <UseCases />

      <FeatureTab
        tabKey="experience"
        isGA={false}
        feature={featureNames.EXPERIENCE_DASHBOARD}
        tabTitle={TAB_TITLE_OVB}
        route="/dashboard/overview"
        exact
      />

      <FeatureTab
        tabKey="trends"
        isGA
        feature={null}
        tabTitle={TAB_TITLE_TRENDS}
        route="/dashboard/trends"
        exact
      />

      <FeatureTab
        tabKey="metric-lens"
        isGA={false}
        feature={featureNames.ML}
        tabTitle={TAB_TITLE_METRIC_LENS}
        route="/dashboard/metriclens"
        exact
      />

      <FeatureTab
        tabKey="real-time"
        isGA
        feature={featureNames.NOC}
        tabTitle={<span>{TAB_TITLE_NOC}</span>}
        route="/dashboard/real-time"
        exact
      />

      <FeatureTab
        tabKey="ai-alerts"
        isGA={false}
        feature={featureNames.AI_ALERTS_PULSE5}
        tabTitle={TAB_TITLE_AIALERTS}
        route="/dashboard/ai-alerts"
        exact
      />

      <FeatureTab
        tabKey="alerts"
        isGA={false}
        feature={featureNames.ALERT_DIAGNOSTICS}
        tabTitle="Manual Alerts"
        route="/alert/manual/summary"
        exact={false}
      />

      <FeatureTab
        tabKey="ai-roadmap"
        isGA={false}
        feature={featureNames.AI_ROADMAP}
        tabTitle={TAB_TITLE_AI_ROADMAP}
        route="/dashboard/ai-roadmap"
        exact
      />

      <FeatureTab
        tabKey="prompt"
        isGA={false}
        feature={featureNames.PROMPT}
        tabTitle={TAB_TITLE_PROMPT}
        route="/dashboard/prompt"
        exact
      />

      <FeatureTab
        tabKey="viewer-module"
        isGA={false}
        feature={featureNames.VIEWER_MODULE_PULSE5}
        tabTitle={VIEWER_MODULE}
        route="/dashboard/viewer-module"
        exact
      />

      {
        // eslint-disable-next-line no-underscore-dangle
        window.__POWERED_BY_QIANKUN__ ? (
          <AccessWrapper feature={featureNames.SAVED_DASHBOARDS}>
            <SavedDashboardsTab />
          </AccessWrapper>
        ) : null
      }

      <TemporaryDashboardTabs renderSharedTab={renderSharedTab} activeId={`${shareId}`} />

      <FeatureToggle feature={featureNames.SAVED_DASHBOARDS} checkRole>
        <>
          <DashboardList id={`${shareId}`} />
        </>
      </FeatureToggle>

      <DashboardPrompt />
    </>
  );
};

export default EIAITabs;
